export const PSTN_SERVICE_NAME = 'PSTN Services';
